/**
 * Frontend Currency Utilities
 * Single source of truth for currency formatting and country/timezone maps.
 * Mirrors the backend currencyConfig.js — keep in sync.
 */

export const CURRENCY_SYMBOLS = {
    CAD: 'CA$',
    USD: '$',
    MXN: 'MX$',
    NPR: 'Rs.'
};

/**
 * Format a monetary amount with the correct currency symbol.
 * Symbol is ALWAYS placed BEFORE the amount.
 *
 * @param {number|string} amount
 * @param {string} currency - e.g. 'CAD', 'NPR', 'USD', 'MXN'
 * @returns {string} e.g. "Rs. 200.00", "CA$ 99.99", "$ 50.00", "MX$ 1,500.00"
 */
export const formatCurrency = (amount, currency = 'CAD') => {
    const symbol = CURRENCY_SYMBOLS[currency] || currency;
    const formatted = (parseFloat(amount) || 0)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `${symbol} ${formatted}`;
};

export const COUNTRY_CURRENCY_MAP = {
    canada: { currency: 'CAD', symbol: 'CA$', timezone: 'America/Toronto', taxLabel: 'HST' },
    usa:    { currency: 'USD', symbol: '$',    timezone: 'America/New_York', taxLabel: 'Sales Tax' },
    mexico: { currency: 'MXN', symbol: 'MX$', timezone: 'America/Mexico_City', taxLabel: 'IVA' },
    nepal:  { currency: 'NPR', symbol: 'Rs.', timezone: 'Asia/Kathmandu', taxLabel: 'VAT' }
};

export const COUNTRY_TIMEZONE_OPTIONS = {
    canada: [
        { label: 'Eastern (Toronto)', value: 'America/Toronto' },
        { label: 'Central (Winnipeg)', value: 'America/Winnipeg' },
        { label: 'Mountain (Calgary)', value: 'America/Edmonton' },
        { label: 'Pacific (Vancouver)', value: 'America/Vancouver' },
        { label: 'Atlantic (Halifax)', value: 'America/Halifax' },
        { label: 'Newfoundland', value: 'America/St_Johns' },
    ],
    usa: [
        { label: 'Eastern (New York)', value: 'America/New_York' },
        { label: 'Central (Chicago)', value: 'America/Chicago' },
        { label: 'Mountain (Denver)', value: 'America/Denver' },
        { label: 'Pacific (Los Angeles)', value: 'America/Los_Angeles' },
    ],
    mexico: [
        { label: 'Central (Mexico City)', value: 'America/Mexico_City' },
        { label: 'Northwest (Tijuana)', value: 'America/Tijuana' },
    ],
    nepal: [
        { label: 'Nepal Standard Time (UTC+5:45)', value: 'Asia/Kathmandu' },
    ]
};

export const CURRENCY_OPTIONS = [
    { value: 'CAD', label: 'CAD — Canadian Dollar' },
    { value: 'USD', label: 'USD — US Dollar' },
    { value: 'MXN', label: 'MXN — Mexican Peso' },
    { value: 'NPR', label: 'NPR — Nepalese Rupee' },
];

export const LANGUAGE_OPTIONS = [
    { value: 'en', label: 'English' },
    { value: 'fr', label: 'French' },
    { value: 'es', label: 'Spanish (Español)' },
    { value: 'ne', label: 'Nepali (नेपाली)' },
];
